import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import CartContext, { CartProvider } from './cartcontent';

import 'react-toastify/dist/ReactToastify.css';

import Home from "./pages/home";
import About from "./pages/aboutpage";
import Order from "./pages/order"
import Orderdetails from "./components/order-tracker"
import CartList from "./pages/cartlist"
import SignUpForm from "./pages/auth/signup";
import LoginForm from "./pages/auth/login";
import CheckoutPage from "./pages/checkout";
import OrderReceivedPage from "./pages/orderreceived";
import DiscountProducts from "./pages/discount";

//categories
import Grain from "./pages/categories/grain";
import Vegetables from "./pages/categories/vegetables";
import Flour from "./pages/categories/flour";
import Oil from "./pages/categories/oil";
import Spices from "./pages/categories/spices";
import Paste from "./pages/categories/paste";
import Beverages from "./pages/categories/bevarages";
import Canned from "./pages/categories/canned";
import Seafoods from "./pages/categories/seafoods";
import Fruits from "./pages/categories/fruits";
import Beauty from "./pages/categories/beauty";
import Ethnic from "./pages/categories/local";
import AfricanSponge from "./pages/categories/africansponge";


import LargeBoxPage from "./pages/specialbox/largebox";
import SmallBoxPage from "./pages/specialbox/smallbox";

import ProductDetail from "./pages/productdetails";

import ContactForm from "./pages/contactus";
import PrivacyPolicy from "./pages/privacy";
import TermsCondition from "./pages/termscondition";
import Blog from "./pages/blog";
import BlogDetail from "./pages/blog-details";

//admin 
import AdminSigninPage from "./admin/auth/login";
import CustomerList from "./admin/dashboard/pages/customer";
import AdminDashboard from "./admin/dashboard/pages/dashboard";
import AdminOrders from "./admin/dashboard/pages/orders";
import AdminProduct from "./admin/dashboard/pages/products";
import CategoryProductsPage from "./admin/dashboard/component/category-product";
import AddProduct from "./admin/dashboard/pages/add-product";
import { SearchProvider } from "./admin/dashboard/service/SearchContext";  // Import SearchContext
import AdminMessages from "./admin/dashboard/pages/contactus";
import AdminBlog from "./admin/dashboard/pages/adminblog";
import Discount from "./admin/dashboard/pages/discounts"
import DriverManagement from "./admin/dashboard/pages/driver"
import SubscriptionManagement from "./admin/dashboard/pages/subscription";
import DeliveryHistory from "./admin/dashboard/pages/delivery";
import ProductSubscriptionManager from "./admin/dashboard/pages/SubscriptionManager";


//Delivery
import DeliveryProtectedroute from "./driver/layout/layout"
import DeliveryLogin from "./driver/auth/login"
import DeliveryDashboard from "./driver/dashboard/index"
import Driverhistory from "./driver/dashboard/history"
import Driverroute from "./driver/dashboard/route"
import Driveravailable from "./driver/dashboard/available"
import Driverprofile from "./driver/dashboard/ProfilePage"
import DriverPendingOrder from "./driver/dashboard/pendingdelivery"



// Import the Admin Layout
import AdminLayout from "./admin/dashboard/layout/layout";
 



//Account
import Accountlayout from "./accounts/layout/layout"
import OverviewPage from "./accounts/pages/overview";
import AccountOrder from "./accounts/pages/order";
import SettingsPage from "./accounts/pages/setting";
import Cardmangement from "./accounts/pages/payment"
import Profile from "./accounts/pages/editpage";
import FavoritePage from "./accounts/pages/favorite";
import ShippingInfo from "./accounts/pages/shippingaddress";
import ProfileUpload from "./accounts/pages/profilepic";
import DeletedAccounts from "./admin/dashboard/pages/deletedaccounts";
import SubscriptionPage from "./accounts/pages/subscription";
import PointsDashboard from "./accounts/pages/point";



//404 not found
import NotFound from "./404"; // Import the NotFound component

function App() {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return (
    <div className="App h-full">
      <SearchProvider>  {/* Wrap the entire app in the SearchProvider */}
        <Routes>
          <Route path="/" element={<Home />} />   
          <Route path="/aboutus" element={<About />} />   
          <Route path="/order" element={<Order />} />  

          <Route path="/contactform" element={<ContactForm />} />   
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />   
          <Route path="/termscondition" element={<TermsCondition />} />
          <Route path="/discounts" element={<DiscountProducts />} />

          <Route path="/order-details/:ordernumber" element={<Orderdetails />} />

          <Route path="/auth/signup" element={<SignUpForm />} />
          <Route path="/auth/login" element={<LoginForm />} />

          <Route path="/cartlist" element={<CartList />} />
          <Route path="/CheckoutPage" element={<CheckoutPage />} />
          <Route path="/OrderReceived/:orderNumber" element={<OrderReceivedPage />} />

          <Route path="/product/:name" element={<ProductDetail />} />


          <Route path="/category/grain" element={<Grain />} />   
          <Route path="/category/fruits" element={<Fruits />} />   
          <Route path="/category/vegetables" element={<Vegetables />} />   
          <Route path="/category/flour" element={<Flour />} />   
          <Route path="/category/oil" element={<Oil />} />   
          <Route path="/category/spices" element={<Spices />} />   
          <Route path="/category/paste" element={<Paste />} />   
          <Route path="/category/beverages" element={<Beverages />} />   
          <Route path="/category/canned" element={<Canned />} />   
          <Route path="/category/seafoods" element={<Seafoods />} />    
          <Route path="/category/beauty" element={<Beauty />} />   
          <Route path="/category/ethnic" element={<Ethnic />} />   
          <Route path="/category/africansponge" element={<AfricanSponge />} />  

          <Route path="/largebox" element={<LargeBoxPage />} />   
          <Route path="/smallbox" element={<SmallBoxPage />} />   

          <Route path="/ContactForm" element={<LargeBoxPage />} />   
          <Route path="/PrivacyPolicy" element={<SmallBoxPage />} /> 
          <Route path="/Blog" element={<Blog />} />
          <Route path="/Blog/:id" element={<BlogDetail />} />

          <Route path="/admin/signin" element={<AdminSigninPage />} />   
          {/* <Route path="/admin/signup" element={<AdminSignupPage />} />  */}

          {/* Admin Routes with Nested Layout */}
          <Route path="/admin" element={<AdminLayout />}>
            {/* <Route path="dashboard" element={<AdminDashboard />} /> */}
            <Route path="orders" element={<AdminOrders />} />
            <Route path="products" element={<AdminProduct />} />
            <Route path="discount" element={<Discount />} />
            <Route path="products/addproduct" element={<AddProduct />} />
            <Route path="customerlist" element={<CustomerList />} />
            <Route path="adminmessages" element={<AdminMessages />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="drivermanagement" element={<DriverManagement />} />
            <Route path="deleted-account" element={<DeletedAccounts />} />
            <Route path="subscription" element={<SubscriptionManagement />} />
            <Route path="delivery-history" element={<DeliveryHistory />} />
            <Route path="subscription-product" element={<ProductSubscriptionManager />} />
            <Route 
            path="/admin/category/:categoryName" 
            element={<CategoryProductsPage />} 
          />
          </Route>

          <Route path="/driver/login" element={<DeliveryLogin />} />   
          {/* <Route path="/admin/signup" element={<AdminSignupPage />} />  */}

          {/* Admin Routes with Nested Layout */}
          <Route path="/driver" element={ <DeliveryProtectedroute/>}>
            <Route path="dashboard" element={<DeliveryDashboard />} />
            <Route path="history" element={<Driverhistory />} />
            <Route path="route" element={<Driverroute />} />
            <Route path="available" element={<Driveravailable />} />
            <Route path="profile" element={<Driverprofile />} />
            <Route path="pending-delivery" element={<DriverPendingOrder />} />
            <Route path="adminmessages" element={<AdminMessages />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="deleted-account" element={<DeletedAccounts />} />

            
          </Route>

           {/* Account Routes with Nested Layout */}
           <Route path="/account" element={<Accountlayout />}>
            <Route path="dashboard" element={<OverviewPage />} />
            <Route path="orders" element={<AccountOrder />} />
            <Route path="setting" element={<SettingsPage />} />
            <Route path="payment" element={<Cardmangement />} />
            <Route path="customerlist" element={<CustomerList />} />
            <Route path="dashboard/profile" element={<Profile />} />
            <Route path="dashboard/shippingdetails" element={<ShippingInfo />} />
            <Route path="favourite" element={<FavoritePage />} />
            <Route path="dashboard/uploadepicture" element={<ProfileUpload />} />
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route path="points" element={<PointsDashboard />} />
           
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </SearchProvider>  {/* Close the SearchProvider here */}
    </div>
  );
}

export default App;
